import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@tempmee/react';
import Styles from '../../themes/style.module.scss';

/**
 * The full-page frame for the screens shown before the shell exists: the boot
 * spinner, "Can't reach the server" and sign-in. The content is centred on the
 * brand background, on a white card unless `bare`.
 */
export const SessionScreen = ({ children, bare, width }) => (
  <div className={Styles.screenView}>
    <div className={bare ? Styles.ModalTransparent : Styles.Modal}>
      {bare ? (
        children
      ) : (
        <Box className="bg-white rounded-lg shadow-md" p={6} width={width}>
          {children}
        </Box>
      )}
    </div>
  </div>
);

SessionScreen.propTypes = {
  children: PropTypes.node.isRequired,
  /** No card: the content sits straight on the background (the boot spinner). */
  bare: PropTypes.bool,
  /** The card's width, e.g. `'360px'`; it fits its content when unset. */
  width: PropTypes.string,
};

SessionScreen.defaultProps = {
  bare: false,
  width: undefined,
};

export default SessionScreen;
